var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('dynamic-router'),_c('login-modal'),_c('upload-kosiwon-modal'),_c('full-indicator')],1)}
var staticRenderFns = []

export { render, staticRenderFns }